import { Observable } from 'rxjs';

import { SignalType, Response } from '@shure/shared/angular/data-access/system-api/models';

import { SignalGeneratorChannel, SignalTarget } from '../models';

export abstract class SignalGeneratorApiService {
	public abstract getChannel$(channelId: string): Observable<SignalGeneratorChannel>;
	public abstract getSignalTargets$(channelIds: string[]): Observable<SignalTarget[]>;
	public abstract toggleSignalEnabled(channelId: string, enabled: boolean): Observable<Response<void, string>>;
	public abstract setSignalType(channelId: string, signalType: SignalType): Observable<Response<void, string>>;
	public abstract setGain(channelId: string, gain: number): Observable<Response<void, string>>;
	public abstract setFrequency(channelId: string, frequency: number): Observable<Response<void, string>>;
	public abstract setSignalTarget(crossPointId: string, enabled: boolean): Observable<Response<void, string>>;
}
